import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_XL,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
  DEFAULT_MARGIN_XS,
} from "@src/common/styles/const";
import { media } from "@src/common/styles/mixins";
import { StyledButton } from "@src/modules/shared/components/Button/Button.components";
import { StatusWrapper } from "@src/modules/shared/components/TestsStatus/TestsStatus.components";

export const ResultsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.down("MOBILE")`
    flex-wrap: wrap;
    gap: ${DEFAULT_MARGIN_M}px;

    & > div{
      justify-content: space-between;
      width: 100%;
    }
  `}
`;

export const ResultsStatusWrapper = styled.div`
  display: flex;
  gap: ${DEFAULT_MARGIN_XL}px;

  ${StatusWrapper} {
    font-size: 10px;
    margin: 0;
  }
`;

export const ResultsButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${DEFAULT_MARGIN_S}px;
`;

export const ResultsButton = styled(StyledButton).attrs({
  buttonType: "tertiary",
})<{ isSaveButton?: boolean }>`
  border: 1px solid ${colors.darkBlue};
  min-height: 24px;
  border-radius: 6px;
  padding: ${DEFAULT_MARGIN_XS}px;

  ${(p) =>
    p.isSaveButton &&
    css`
      color: ${colors.white};
      background-color: ${colors.darkBlue};

      &:hover {
        color: ${colors.white};
        background-color: ${colors.darkBlue2};
      }
    `}
`;

export const BenchmarkButton = styled(ResultsButton)<{ isBaseTest: boolean }>`
  ${(p) =>
    p.isBaseTest &&
    css`
      svg {
        fill: currentColor;
      }
    `}
`;
